import React from 'react';

export default function InfoIcon({ className = '', title }) {
  return (

    <svg
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M8.05494 11.0256C7.59747 11.0256 7.2271 11.4069 7.2271 11.8644C7.2271 12.311 7.58657 12.7031 8.05494 12.7031C8.52332 12.7031 8.89369 12.311 8.89369 11.8644C8.89369 11.4069 8.51247 11.0256 8.05494 11.0256Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.6"
      />
      <path
        d="M8.19656 4.67506C6.72603 4.67506 6.05069 5.54647 6.05069 6.13469C6.05069 6.55953 6.41013 6.7556 6.70425 6.7556C7.29244 6.7556 7.05281 5.91685 8.16388 5.91685C8.70853 5.91685 9.14425 6.1565 9.14425 6.65756C9.14425 7.24581 8.53425 7.58347 8.17478 7.88847C7.85891 8.16078 7.44497 8.60741 7.44497 9.54419C7.44497 10.1106 7.59744 10.274 8.04406 10.274C8.57781 10.274 8.68672 10.0344 8.68672 9.82741C8.68672 9.26097 8.69766 8.93419 9.29675 8.46581C9.59085 8.23706 10.5168 7.49635 10.5168 6.47241C10.5168 5.44847 9.59085 4.67506 8.19656 4.67506Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.6"
      />
      <path
        d="M8.3 0.300003C3.87863 0.300003 0.300003 3.87803 0.300003 8.3V15.675C0.300003 16.0202 0.579816 16.3 0.925003 16.3H8.3C12.7213 16.3 16.3 12.722 16.3 8.3C16.3 3.87863 12.722 0.300003 8.3 0.300003ZM8.3 15.05H1.55V8.3C1.55 4.56947 4.56897 1.55 8.3 1.55C12.0305 1.55 15.05 4.56897 15.05 8.3C15.05 12.0305 12.031 15.05 8.3 15.05Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.6"
      />
    </svg>

  );
}

